import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '@/components/atoms/Text/Text';
import Section from '@/components/molecules/Section/Section';

const AccessibilityContent: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <Text variant="title" className="mb-2">{t('termsAndPrivacyModal.accessibility.title')}</Text>
        <Text variant="caption">{t('termsAndPrivacyModal.accessibility.effectiveDate')}</Text>
      </div>
  
      <div className="space-y-4">
        <Section number="1" title={t('termsAndPrivacyModal.accessibility.sections.commitment.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.accessibility.sections.commitment.content')}
        </Section>
        
        <Section number="2" title={t('termsAndPrivacyModal.accessibility.sections.features.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.accessibility.sections.features.content')}
        </Section>
        
        <Section number="3" title={t('termsAndPrivacyModal.accessibility.sections.feedback.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.accessibility.sections.feedback.content')}
        </Section>
      </div>
    </div>
  );
};

export default AccessibilityContent;